import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { confirmPhoneOtp, requestPhoneOtp } from '../api/authVerification'
import { useUser } from '../contexts/UserContext'

const VerifyPhonePage = () => {
  const navigate = useNavigate()
  const { user, refreshUser } = useUser()

  const [code, setCode] = useState('')
  const [sending, setSending] = useState(false)
  const [confirming, setConfirming] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [devCode, setDevCode] = useState<string | null>(null)

  const send = async () => {
    try {
      setSending(true)
      setMessage(null)
      const res = await requestPhoneOtp()
      setDevCode(res.devCode || null)
      setMessage('Verification code sent.')
    } catch (e: any) {
      setMessage(e?.message || 'Failed to send code.')
    } finally {
      setSending(false)
    }
  }

  const confirm = async () => {
    try {
      setConfirming(true)
      setMessage(null)
      await confirmPhoneOtp(code.trim())
      await refreshUser()
      setMessage('Phone verified successfully.')
    } catch (e: any) {
      setMessage(e?.message || 'Failed to verify phone.')
    } finally {
      setConfirming(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white border border-gray-200 rounded-lg shadow-sm p-6">
        <h1 className="text-xl font-bold text-gray-900">Verify Phone</h1>
        <p className="text-sm text-gray-600 mt-1">
          {user?.phone && !user.phone.startsWith('__pending__')
            ? `Code will be sent to ${user.phone}.`
            : 'Add a phone number during onboarding, then return here to verify.'}
        </p>

        {message && (
          <div className="mt-4 bg-gray-50 border border-gray-200 rounded-md p-3 text-sm text-gray-800">{message}</div>
        )}

        {devCode && (
          <div className="mt-3 bg-yellow-50 border border-yellow-200 rounded-md p-3 text-xs text-yellow-900">
            Dev code (non-production): <span className="font-semibold">{devCode}</span>
          </div>
        )}

        <div className="mt-6 flex flex-col gap-3">
          <button onClick={send} disabled={sending} className={`btn-primary ${sending ? 'opacity-60 cursor-not-allowed' : ''}`}>
            {sending ? 'Sending…' : 'Send code'}
          </button>

          <div className="flex gap-2">
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="6-digit code"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
              inputMode="numeric"
            />
            <button
              onClick={confirm}
              disabled={confirming || code.trim().length < 4}
              className={`btn-outline ${confirming ? 'opacity-60 cursor-not-allowed' : ''}`}
            >
              {confirming ? 'Verifying…' : 'Verify'}
            </button>
          </div>

          <button onClick={() => navigate('/')} className="btn-outline">
            Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default VerifyPhonePage


